import { render } from "./ApolicesView.vue?vue&type=template&id=5da6e436"
import script from "./ApolicesView.vue?vue&type=script&lang=js"
export * from "./ApolicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__